export const on = (element, type, listener, capture = false) => {
  element.addEventListener(type, listener, capture);
  return element.removeEventListener.bind(element, type, listener, capture);
};
